import { bindClient } from "@spiriidk/utils";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getAuthzContext } from "connect-api/authz/api/get-authz-context";

import { typedFetchNoImpersonate } from "~/api/typed-fetch";

const authzContextApi = bindClient(
  { getAuthzContext },
  typedFetchNoImpersonate
);

const authzContextQueryOptions = {
  all: () => ["authz"] as const,
  current: () =>
    queryOptions({
      queryKey: [...authzContextQueryOptions.all(), "current"] as const,
      queryFn: ({ signal }) => authzContextApi.getAuthzContext(signal),
      staleTime: Infinity,
    }),
};

interface UseAuthzContextOptions {
  enabled: boolean;
}

function useAuthzContext({ enabled }: UseAuthzContextOptions) {
  return useQuery({ ...authzContextQueryOptions.current(), enabled });
}

export { authzContextQueryOptions, useAuthzContext };
